export default "__VITE_ASSET__D5gTr_48__"